// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__34O_w","info":"PatientInfo_info__2n2Sx"};